import {CommentsContainer, MessageItem} from "../CommentsContainer/CommentsContainer";
import React, {useContext, useEffect, useRef, useState} from "react";
import customAxios from "../../../service/api/interceptors";
import {UserType} from "../../../enums/userType";
import {MainContextProvider} from "../../../context/MainContext";
import {UserProfileResponse} from "../../../service/userProfile/userProfile.type";
import {useLocation} from "react-router-dom";
import pushNotifications from "../../../helpers/pushNotifications";
import { EventEmitter } from 'events';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {setChats, setSelectedChatId, setTabNotifications} from "../../../redux/slices/ChatSlice";


const GroupCommentsPhoto = ({ users, currentUserId }: { users: UserProfileResponse[], currentUserId: string }) => {
    const allUsers = users.filter((user: UserProfileResponse) => String(user.user_id) !== currentUserId)

    if (allUsers.length === 1) {
        return (
            <div className={'comment-list__group-photo'}>
                <div className={"comment-list__group-photo-item"}>
                    <img src={allUsers[0].avatar_url} alt=""/>
                </div>
            </div>
        )
    } else {
        return (
            <div className={'comment-list__group-photo'}>
                <div className="comment-list__group-photo-items">
                    {
                        allUsers.map((user, i) => {
                            if (allUsers.length === 4 ? i <= 3 : i <= 2) {
                                return (
                                    <div>
                                        <img src={user.avatar_url} alt=""/>
                                    </div>
                                )
                            }
                        })
                    }
                    {allUsers.length > 4 && <b>{allUsers.length - 3}+</b>}
                </div>
            </div>
        )
    }
}

export const GroupComments: React.FC<any> = ({ id, entity, isUnSubscribe, setTabsCounter, tabsCounter, updateChatIndex, setChatCount, offer_id, isHideContent, isPaused }) => {
    const chatArr = useSelector((state: RootState) => state.chat.chats);
    const tabNotifications = useSelector((state: RootState) => state.chat.tabNotifications);
    const chatId = useSelector((state: RootState) => state.chat.selectedChatId);
    const dispatch = useDispatch();
    const { userData, centrifuge } = useContext(MainContextProvider)
    const [items, setItems] = useState<{ id: string; name: string; users: UserProfileResponse[]; count: number }[]>([])
    //const [chats, setChats] = useState<any[]>([])
    const [activeChatId, setActiveChatId] = useState<string | null>(null)
    const [unSeenMessages, setUnSeenMessages] = useState<{ id: string; new_comments_count: string }[]>([])
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const isSocketConnected = useRef(false)
    const activeChatIdRef = useRef<string | null>(null)
    const unSeenMessagesRef = useRef<{ id: string; new_comments_count: string }[]>([])
    const subscriptionsRef = useRef<any[]>([])

    const getChats = async () => {
        const initialChatId = searchParams.get('chat_id')
        try {
            const { data: newCommentsCount } = await customAxios.get(`/${entity}/${id}/new-comments-count`)
            const prData =
                entity === 'partner-request' && userData?.status.type_code === 200
                    ? (await customAxios.get(`/chat/general/partner-request/${id}`)).data
                    : []

            const { status, data } = await customAxios.get(`/chat/${entity}/${id}`)
            if (status === 200) {
                const all = [...data, ...(prData || [])].map((el: any) => ({ ...el, count: 0 }))
                dispatch(setChats(all))

                const found = all.find(el => String(el.id) === initialChatId)
                const firstId = found ? initialChatId! : all[0]?.id
                dispatch(setSelectedChatId(firstId))
                setActiveChatId(firstId)
                activeChatIdRef.current = firstId

                dispatch(setTabNotifications(newCommentsCount.map((el: any) => {
                    if (String(chatId) === String(el.id)) {
                        return { id: el.id, new_comments_count: '0' }
                    } else return { id: el.id, new_comments_count: el.new_comments_count }
                })))

                setChatCount && setChatCount(all.length)
                //connectSocket(all)
            }
        } catch (e) {
            console.error(e)
        }
    }

    const getUnSeenMessages = async () => {
        try {
            const { status, data } = await customAxios.get(`/${entity}/${id}/new-comments-count`)
            if (status === 200) {

                console.log(data)
                const updated = (data as any[]).map(el =>
                    String(el.id) === String(activeChatIdRef.current)
                        ? { ...el, new_comments_count: '0' }
                        : el
                )
                setUnSeenMessages(updated)
                unSeenMessagesRef.current = updated
            }
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getChats()
        return () => {
            subscriptionsRef.current.forEach(sub => sub.unsubscribe())
            subscriptionsRef.current = []
            isSocketConnected.current = false
        }
    }, [
        entity, id,
        // updateChatIndex
    ])

    useEffect(() => {
        if (activeChatId && unSeenMessagesRef.current.length === 0) {
            // getUnSeenMessages()
        }
    }, [activeChatId])

    const setActiveChat = (chat_id: string) => {
        dispatch(setSelectedChatId(+chat_id))

        dispatch(setTabNotifications(tabNotifications.map(el => {
            if (String(chatId) === String(el.id)) {
                return { id: el.id, new_comments_count: '0' }
            } else return { id: el.id, new_comments_count: el.new_comments_count }
        })))
    }

     const getUnSeenMessageCount = (fChatId: string) => {
        if (String(chatId) !== fChatId) {
            return tabNotifications.find(el => String(el.id) === String(fChatId))?.new_comments_count || 0
        }
        return 0
     }

    return (
        <div>
            {chatArr.length > 1 && (
                <div className="comment-list__header">
                    {chatArr.map(chat => (
                        <div
                            key={chat.id}
                            onClick={() => setActiveChat(chat.id)}
                            className={`comment-list__header-el ${
                                String(chat.id) === String(chatId) ? 'comment-list__header-el-active' : ''
                            }`}
                        >
                            <GroupCommentsPhoto users={chat.users} currentUserId={String(userData?.user_id)} />
                            <span>
                {chat.name}
                                {getUnSeenMessageCount(String(chat.id)) > 0 && (
                                        <em>
                                            {getUnSeenMessageCount(String(chat.id))}
                                        </em>
                                    )}
              </span>
                        </div>
                    ))}
                </div>
            )}

            {chatId && (
                <CommentsContainer
                    chats={items}
                    chat_id={chatId + ""}
                    entity_id={id}
                    postMessage={text => {}}
                    setMessages={() => {}}
                    link="/company/comment/"
                    linkToGetMessages="offer"
                    linkToSend={`/comment/chat/${chatId}`}
                    isUnSubscribe={isUnSubscribe}
                    setCounterData={count =>
                        setTabsCounter && setTabsCounter({ ...tabsCounter, offers: count })
                    }
                    fullScreenChat={false}
                    setFullScreenChat={() => {}}
                    pr_offer_id={offer_id}
                    isHideContent={isHideContent}
                    isPaused={isPaused}
                />
            )}
        </div>
    )
}